<template>
<div v-if="showPasswordModal" class="modal top-0 bottom-0 w-full h-full fixed flex justify-center items-center">
    <div class="overlay fixed w-full h-full top-0"></div>
    <div class="modal-content w-full relative">
        <!-- close button -->
        <div @click="close" class="close absolute flex flex-row justify-center items-center text-white cursor-pointer">
            <img :src="require('../../assets/close.png')" alt="" />
        </div>

        <div class="bg-white px-8 py-4 ">
            <div class="modal-title font-semibold mb-12">Password</div>
            <div class="flex flex-row">
                <div class="flex flex-col flex-grow items-start mb-12 mr-12">
                    <div class="flex flex-row items-center form-row mb-8">
                        <div class="modal-field font-semibold">Current Password:</div>
                        <div class="flex-grow ml-auto">
                            <linput type="password" name="fname" v-model="form.old_password" :errorMessage="errors.old_password" :error="errors.old_password" placeholder="Current Password" />
                        </div>
                    </div>
                    <div class="flex flex-row items-center form-row mb-8">
                        <div class="modal-field font-semibold ">New Password:</div>
                        <div class="flex-grow ml-auto">
                            <linput type="password" v-model="form.password" :errorMessage="errors.password" :error="errors.password" placeholder="New Password" />
                        </div>
                    </div>

                    <div class="flex flex-row items-center form-row mb-8">
                        <div class="modal-field font-semibold ">
                            Password Confirmation:
                        </div>
                        <div class="flex-grow ml-auto">
                            <linput type="password" v-model="form.password_confirmation" :errorMessage="errors.password_confirmation" :error="errors.password_confirmation" placeholder="Password Confirmation" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-center items-center">
                <div class="mb-8">
                    <lms-button @click="handleFormSubmit">Update Password</lms-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex";
export default {
    data() {
        return {
            errors: [],
            form: {},
        };
    },
    model: {
        prop: "showPasswordModal",
        event: "closeAdminModal",
    },
    props: {
        showPasswordModal: {
            type: Boolean,
            required: true,
            default: false,
        },
    },

    methods: {
        ...mapActions(["updateProfile"]),
        async handleFormSubmit() {
            //console.log("kkkkkkkk");
            if (this.form.old_password === '' || this.form.old_password === null || typeof this.form.old_password === 'undefined') {
                this.$emit("notify", {
                    type: "error",
                    message: "Please Provide Your Current Password",
                });
                return;
            }
            if (this.form.password === '' || this.form.password === null || typeof this.form.password === 'undefined') {
                this.$emit("notify", {
                    type: "error",
                    message: "Please Provide Your New  Password",
                });
                return;
            }
            if (this.form.password_confirmation !== this.form.password) {
                this.$emit("notify", {
                    type: "error",
                    message: "Password Confirmation does not match",
                });
                return;
            }
            this.errors = [];
            let res = await this.updateProfile(this.form);

            if (res.status == 200) {
                this.$emit("notify", {
                    type: "success",
                    message: "Password updated successfully",
                });
                this.form = {};
                this.close();
            } else {
                if (res.status == 400) {
                    this.$Bus.$emit("notify", {
                        type: "error",
                        message: res.data.errors ?
                            res.data.errors[0].title : "An error occured",
                    });
                }
            }
        },
        close() {
            this.$emit("closeAdminModal", false);
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        LmsButton: () => import("@/components/general/button"),
        lselect: () => import("@/components/forms/select"),
    },
};
</script>

<style lang="scss" scoped>
.form-row {
    width: 100%;
}

.modal {
    z-index: 10;

    .overlay {
        background: #b1b3b9;
        opacity: 0.89;
        z-index: 0;
    }

    .modal-content {
        width: 100%;
        width: 1001px !important;

        .modal-title {
            font-size: 24px;
            color: color(lms-admin);
        }

        .modal-field {
            color: color(lms-admin);
            max-width: calc(135px + 16px);
            width: 100%;
        }

        .close {
            background-color: #c2454b;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            font-size: 12px;
            top: -17px;
            z-index: 2;
            right: -16px;
        }

        z-index: 1;
    }
}
</style>
